module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page"
  }, [(_vm.toast) ? _c('mu-toast', {
    attrs: {
      "message": _vm.hintMsg,
      "id": "alertline"
    },
    on: {
      "close": _vm.hideToast
    }
  }) : _vm._e(), _vm._v(" "), _c('mu-appbar', {
    staticStyle: {
      "height": "1rem"
    }
  }, [_c('mu-icon', {
    staticStyle: {
      "margin-top": "0.05rem"
    },
    attrs: {
      "slot": "left",
      "value": "keyboard_arrow_left",
      "color": "white"
    },
    on: {
      "click": function($event) {
        return _vm.goback()
      }
    },
    slot: "left"
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center",
      "font-size": "0.38rem"
    }
  }, [_vm._v("新闻详情")]), _vm._v(" "), _c('mu-icon', {
    staticStyle: {
      "margin-bottom": "-0.05rem"
    },
    attrs: {
      "slot": "right",
      "value": "keyboard_arrow_left",
      "color": "#27ba69"
    },
    slot: "right"
  })], 1), _vm._v(" "), (!_vm.Isloading) ? _c('div', {
    staticStyle: {
      "background-color": "#fff",
      "min-height": "12.4rem",
      "margin": "auto auto",
      "color": "#666"
    },
    attrs: {
      "id": "Gxx1214"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": _vm.AllInfo.Pic
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "background-color": "#ddd",
      "line-height": "2",
      "padding-left": "0.2rem",
      "font-weight": "bolder",
      "margin-top": "-0.1rem"
    }
  }, [_c('div', {
    staticStyle: {
      "font-size": "0.32rem"
    }
  }, [_vm._v(_vm._s(_vm.AllInfo.Title))])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "line-height": "2",
      "padding-left": "0.2rem",
      "font-weight": "bolder"
    }
  }, [_c('div', {
    staticStyle: {
      "font-size": "0.2rem"
    }
  }, [_vm._v("来源：" + _vm._s(_vm.AllInfo.Author))]), _vm._v(" "), _c('div', {
    staticStyle: {
      "font-size": "0.2rem"
    }
  }, [_vm._v("发布时间：" + _vm._s(_vm.AllInfo.Create_Time))])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "background-color": "#ddd",
      "height": "0.2rem"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "95%",
      "margin": "auto auto"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.HtmlCode)
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "1rem"
    }
  })]) : _c('div', {
    staticClass: "loading",
    staticStyle: {
      "background-color": "white"
    }
  }, [_c('div', {
    staticStyle: {
      "height": "0.7rem",
      "background-color": "white"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../../../static/LoadingBest.gif")
    }
  })])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-99ac175e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Home/NewsDetailsPage.vue
// module id = 1571
// module chunks = 18